var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 148.2 79.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a970fdd8-82bf-4fdb-a745-eb6af556f5a9,.bb98b160-7cad-4bc6-b6cd-a9d22058bc47{fill:none;stroke:#b7b7b7;stroke-miterlimit:10;}.bb98b160-7cad-4bc6-b6cd-a9d22058bc47{stroke-width:4px;}.f65a18f5-c0bf-4e1b-96a1-188a59b407e2{fill:#b7b7b7;}.a970fdd8-82bf-4fdb-a745-eb6af556f5a9{stroke-width:14.1px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ad7f6bfa-489f-4c2f-a38c-846c468c9289",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e049942c-bfcc-483f-9ae7-6abe52b992e2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "bb98b160-7cad-4bc6-b6cd-a9d22058bc47",
    x: 2,
    y: 2,
    width: 144.2,
    height: 75.56,
    rx: 13.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "f65a18f5-c0bf-4e1b-96a1-188a59b407e2",
    d: "M136.5,57.64a7.51,7.51,0,1,1-15,0h0a7.51,7.51,0,1,1,15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f65a18f5-c0bf-4e1b-96a1-188a59b407e2",
    d: "M118.87,49.92a7.72,7.72,0,0,0,0,15.44,7.36,7.36,0,0,0,5-2h0a6.62,6.62,0,0,0,.76-.83H123.2a6,6,0,0,1-.56-.79h2.65a8.21,8.21,0,0,0,.44-.83H122.2a5.64,5.64,0,0,1-.31-.81H126a7.91,7.91,0,0,0,.39-2.45,7.45,7.45,0,0,0-.18-1.65h-4.59a6.87,6.87,0,0,1,.22-.81H126c-.1-.29-.21-.56-.33-.83H122.2a7.82,7.82,0,0,1,.43-.81h2.65a8.19,8.19,0,0,0-.58-.83h-1.48a6.91,6.91,0,0,1,.75-.78,7.34,7.34,0,0,0-5-2Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a970fdd8-82bf-4fdb-a745-eb6af556f5a9",
    x1: 2,
    y1: 23.81,
    x2: 146.2,
    y2: 23.81
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.0513950c5e78864ba67a6efa44c83d6b.svg";
export { ForwardRef as ReactComponent };